<template>
  <div class="navbar">
    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <span v-if="store.kind === 4 || store.kind === 6 || store.kind === 7" :class="`takeout-tag ${this.store.enableshipping === 1 ? 'takeout-tag-b' : ''}`" @click="updateStore" ref="takeoutBtn">
        <img :src="this.store.enableshipping === 1 ? '/img/takeout-icon-b.png' : '/img/takeout-icon.png'" width="16px" />
        {{ this.store.enableshipping === 2 ? '已开启自动打印' : '未开启自动打印' }}
      </span>

      <el-dropdown
        @click.native="
          () => {
            hasnew = false;
            list = getNotificationList();
          }
        "
        @command="onClickDropDown"
        class="message-tips-icon"
        trigger="click"
      >
        <div class="message-bell">
          <i class="el-icon-bell" style="padding: 10px; cursor: pointer; color: #ff4f4f;" />
          <div class="message-dot" v-show="hasnew"></div>
        </div>

        <el-dropdown-menu slot="dropdown">
          <div class="message-box" v-if="!list.length">
            <div class="message-box-item">
              <div class="message-box-text">暂无消息</div>
              <div class="message-box-already-read"></div>
            </div>
          </div>
          <div class="message-box" v-if="list.length">
            <div class="message-box-item" v-for="item in list" :key="item.time">
              <div class="message-box-text" :style="item.kind === 11 ? 'color:#ff4f4f' : ''">{{ item.content }}</div>
              <div class="message-box-time">{{ new Date(item.time * 1000).toLocaleString() }}</div>
              <div class="message-box-already-read" v-if="item.read"></div>
            </div>
          </div>
          <el-button size="small" v-if="list.length" type="text" @click="clearNotification" style="position:absolute;right:10px;bottom:5px;">清除消息</el-button>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown @command="onClickDropDown" class="avatar-container right-menu-item" trigger="click">
        <el-button size="small" type="text">
           当前商城: [{{['通用商城', '到店核销', '教育培训', '到店核销时段版', '周边周期购', '', '周边零售', '餐饮外卖'][store.kind]}}/{{ store.name }}/{{ role.name }}/{{ admin.name }}]
          <i class="el-icon-arrow-down" />
        </el-button>
        <el-button size="small" type="text" @click="()=>this.showSwitchStore = true">
            切换商城
          <i class="el-icon-arrow-down" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changeMobile">{{ '修改手机号' }}</el-dropdown-item>
          <!-- <el-dropdown-item command="wechatkefu">{{ '微信客服' }}</el-dropdown-item> -->
          <el-dropdown-item command="signout">{{ '退出登录' }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 切换商城 -->
    <el-dialog :visible.sync="showSwitchStore" title="切换商城" width="300px">
      <el-form ref="form" size="small">
        <el-form-item>
          <el-select v-model="storeid">
            <el-option :key="store.id" :label="['通用商城', '到店核销', '教育培训', '到店核销时段版', '周边周期购', '', '周边零售', '餐饮外卖'][store.kind] + ': ' + store.name" :value="store.id" v-for="store in canSwtichStoreList"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer fr-jcfs" slot="footer">
        <el-button @click="onSwitchStore" size="small" type="primary">切换</el-button>
      </div>
    </el-dialog>
    <!-- 修改手机号 -->
    <el-dialog :visible.sync="showChangeMobile" title="修改手机号" width="300px">
      <change-mobile @success="changeMobileSuccess"></change-mobile>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc1, rpc } from '../../../service/index';
import { M, invoke } from '../../../service/grpc';
import { getToken, setToken, delToken, addNotification, getNotificationList, clearNotificationList } from '../../../service/helper';
import { mapGetters } from 'vuex';
import changeMobile from './changemobile.vue';
import breadCrumb from './breadCrumb/index.vue';

export default {
  data() {
    return {
      domain: localStorage.getItem('domain'),
      token: getToken(),
      admin: {},
      role: {},
      store: {},
      storeid: 0,
      list: [],
      hasnew: false,

      canSwtichStoreList: [],
      showSwitchStore: false,
      showChangeMobile: false
    };
  },
  components: {
    // 'menu-trigger': menuTrigger,
    changeMobile,
    breadcrumb: breadCrumb
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar', 'device'])
  },
  async created() {
    rpc1('StoreAuthService.GetAuth', M('Token', { token: this.token })).then(res => {
      this.admin = res;
      rpc1(
        'StoreStoreRoleService.GetStoreRole',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: this.admin.storeroleid
        })
      ).then(res1 => {
        this.role = res1;
      });
    });
    rpc1('StoreAuthService.GetStore', M('Token', { token: this.token })).then(res => {
      this.store = res;
      rpc1('StoreAuthService.GetStoreList', M('Token', { token: this.token })).then(res => {
        this.canSwtichStoreList = res.storelistList;
        const rows = this.canSwtichStoreList.find(item => item.id === this.store.id);
        this.storeid = rows.id;
      });
    });

    if (window.Notification && window.Notification.permission === 'default') {
      await Notification.requestPermission();
    }
    const listen = () => {
      invoke(
        'StoreNotificationService.GetNotification',
        M('Token', { token: this.token }),
        res => {
          let msg = '';
          if (res.kind === 1) {
            msg = '您有新的订单';
          }
          // 普通提示
          if (res.kind === 2) {
            msg = res.content;
            addNotification(res.kind, res.content);
            this.hasnew = true;
          }
          // 错误提示
          if (res.kind === 11) {
            msg = res.content;
            addNotification(res.kind, res.content);
            this.hasnew = true;
          }
          try {
            if (window.Notification) {
              var n = new Notification('3306通知', {
                body: msg,
              });
              n.onclick = function() {
                window.focus();
              };
            }
          } catch (e) {}
        },
        e => {
          console.log(e);
          setTimeout(listen, 5000);
        }
      );
    };
    listen();
  },
  methods: {
    clearNotification() {
      clearNotificationList();
      this.list = [];
    },
    getNotificationList,
    changeMobileSuccess() {
      this.showChangeMobile = false;
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    },
    onClickDropDown(command) {
      if (command === 'signout') {
        delToken();
        window.location = '/';
        return;
      }

      if (command === 'switchStore') {
        this.showSwitchStore = true;
        return;
      }

      if (command === 'changeMobile') {
        this.showChangeMobile = true;
        return;
      }

      if (command === 'wechatkefu') {
        window.open('https://mpkf.weixin.qq.com/', '_blank');
      }
    },
    updateStore() {
      const params = JSON.parse(JSON.stringify(this.store));
      params.enableshipping = params.enableshipping == 1 ? 2 : 1;
      rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...params,
            businesshoursList: params.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: params.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      ).then(res => {
        this.store = res;
      });
    },
    onSwitchStore() {
      if (this.storeid === this.store.id) {
        this.$message({
          message: '当前就在这个商城'
        });
        return;
      }
      rpc1(
        'StoreAuthService.AuthStore',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: this.storeid
        })
      ).then(res => {
        setToken(res.token);
        window.location = '/';
      });
    }
  }
};
</script>

<style lang="scss">
.message-tips-icon {
  margin-left: 5px;
  padding-left: 10px;
  padding-right: 0;
}
.message-bell {
  position: relative;
}
.message-dot {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: #ff4f4f;
  position: absolute;
  top: 13px;
  right: 6px;
}
.message-box {
  width: 260px;
  max-height: 300px;
  overflow-y: scroll;
}
.message-box-item {
  padding: 10px 15px;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
}
.message-box-already-read {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.6);
}
.message-box-item:last-child {
  border: none;
}
.message-box-text {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}
.message-box-time {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.box-wrap {
  width: 300px;
  min-height: 100px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #f8f8f8;
  position: absolute;
  top: 40px;
  right: 10px;
}
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  background-color: #fff;
  margin-bottom: 10px;
  .menu-trigger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .takeout-tag {
    display: inline-block;
    padding: 4px 8px;
    line-height: 16px;
    color: #ff4f4f;
    background-color: #fff3f3;
    border-radius: 2px;
    cursor: pointer;
    & > * {
      vertical-align: middle;
    }
  }
  .takeout-tag-b {
    color: #aaa;
    background-color: #eee;
  }
  .right-menu {
    display: flex;
    align-items: center;
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .app-tips {
      margin-right: 10px;
      padding: 0 10px;
      cursor: pointer;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 15px;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 7px;
        position: relative;
        .user-avatar {
          box-sizing: border-box;
          border: 1px solid #ececec;
          cursor: pointer;
          width: 36px;
          height: 36px;
          border-radius: 6px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
